"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = exports.TCounterChange = void 0;
const React = require("react");
const react_1 = require("react");
const CircularIcon_1 = require("../../atoms/CircularIcon");
const KeypadWrapper_1 = require("../../atoms/KeypadWrapper");
const Keypad_1 = require("../../atoms/Keypad");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const styles = require("./styles.scss");
const css = (0, cssComposer_1.default)(styles);
var TCounterChange;
(function (TCounterChange) {
    TCounterChange["Increment"] = "increment";
    TCounterChange["Decrement"] = "decrement";
})(TCounterChange = exports.TCounterChange || (exports.TCounterChange = {}));
/**
 * Number input
 */
const NumberInput = ({ onInputChange, onBlur, incrementValue, value, placeholder, disabled, minValue, maxValue, hideKeypad = false, hint, alwaysShowKeypad = false }) => {
    const inputRef = (0, react_1.useRef)(null);
    const onChange = (evt) => {
        let newValue = evt.target.value;
        // only allows valid numbers
        // this still allows for leading/trailing zeroes, a single dash and negative
        // zero
        // this is so we can still enter valid values without it being reset
        // the pattern on the component however should complain about not valid
        // numbers
        const match = newValue.match(/^-$|^-?[0-9]*(?:\.[0-9]*)?$/g);
        if (match === null) {
            newValue = evt.target.defaultValue;
        }
        // still need to check value is in range as we have bypassed normal input change
        const numberValue = Number(newValue);
        if (typeof minValue === "number" && numberValue < minValue) {
            return;
        }
        if (typeof maxValue === "number" && numberValue > maxValue) {
            return;
        }
        // update value
        onInputChange(newValue);
    };
    // need to use text to allow for partial inputs using the keypad, e.g. "10."
    const input = (React.createElement("input", { ref: inputRef, "data-test": "input", "data-hint": hint, type: "text", onChange: onChange, onBlur: onBlur, onClick: evt => evt.stopPropagation(), 
        // need to check string and number value as the counters will
        // convert and not allow zero
        value: value || typeof value === "number" ? `${value}` : "", placeholder: placeholder, disabled: disabled, min: minValue, max: maxValue, pattern: "^-?[0-9]\\d*(\\.\\d+)?$" }));
    const wrapComponent = (component) => {
        const numValue = typeof value === "number" ? value : parseFloat(value);
        // function to change value on counter click
        const changeValue = (0, react_1.useCallback)((type) => {
            // need to check if parsed number is NaN
            // otherwise the input will put that as the value
            if (isNaN(numValue)) {
                return;
            }
            const setValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
            // increment / decrement value based on the counter clicked
            const updatedValue = type === TCounterChange.Decrement
                ? numValue - incrementValue
                : numValue + incrementValue;
            setValue.call(inputRef.current, updatedValue.toString());
            // update the input value
            const e = new Event("input", { bubbles: true });
            inputRef.current.dispatchEvent(e);
        }, [numValue, inputRef]);
        return (React.createElement("div", { className: css("counters") },
            React.createElement("span", { className: css("counters_counter", "-left"), "data-test": "minus-counter" },
                React.createElement(CircularIcon_1.default, { className: css("counters_icon"), name: "minus", onClick: () => changeValue(TCounterChange.Decrement) })),
            component,
            React.createElement("span", { className: css("counters_counter", "-right"), "data-test": "plus-counter" },
                React.createElement(CircularIcon_1.default, { className: css("counters_icon"), name: "plus", onClick: () => changeValue(TCounterChange.Increment) }))));
    };
    const component = incrementValue !== undefined ? wrapComponent(input) : input;
    return hideKeypad ? (component) : (React.createElement(KeypadWrapper_1.KeypadWrapper, { inputComponent: component, alwaysShowKeypad: alwaysShowKeypad, keypadComponent: React.createElement(Keypad_1.NumberKeypad, null) }));
};
exports.NumberInput = NumberInput;
//# sourceMappingURL=index.js.map